import EditMileageRateModal from './globalSettings/EditMileageRateModal';

export {
  EditMileageRateModal
};



// WEBPACK FOOTER //
// ./src/components/modal/index.js